import { formatDateWithTime, gridSizeMdLg6 } from "@/shared"
import { CustomTextField, CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui"

export type OTVisitaTecnicoFormTabProps = {
    form: any,
    errors: any,
    shrink: boolean
}
export default function OTVisitaTecnicoFormTab({
    form,
    errors,
    shrink = false
}: OTVisitaTecnicoFormTabProps) {
    console.log(form)
    return (
        <>
            <TabTextLabel
                text="Datos Generales"
                pb={1}
                pt={1}
            />
            <CustomTextField
                label="Tipo Orden Servicio"
                name="tipo_orden_servicio"
                control={form.control}
                defaultValue={form.getValues().tipo_orden_servicio || ""}
                error={errors.tipo_orden_servicio}
                helperText={errors.tipo_orden_servicio?.message}
                shrink={shrink}
                disabled
            />
            <CustomTextField
                name="flota_data.nombre"
                label="Flota"
                control={form.control}
                defaultValue={form.getValues()?.flota_data?.nombre || ""}
                error={errors?.flota_data?.nombre}
                helperText={errors?.flota_data?.nombre?.message || ""}
                disabled
            />
            <CustomTextField
                label="Fecha de Visita"
                name="fecha_visita"
                control={form.control}
                defaultValue={form.getValues()?.fecha_visita || ""}
                error={errors?.fecha_visita}
                helperText={errors?.fecha_instalacion?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                label="Hora de Visita"
                name="hora_visita"
                control={form.control}
                defaultValue={form.getValues()?.hora_visita || ""}
                error={errors?.hora_visita}
                helperText={errors?.hora_visita?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
                disabled
            />
            <TabTextLabel text="HORA DE INICIO/FINALIZACIÓN" pt={1} pb={1} />
            <CustomTextFieldNoForm
                label="Hora de Inicio"
                value={
                    form.getValues()?.fecha_hora_inicio_visita ?
                        formatDateWithTime(form.getValues().fecha_hora_inicio_visita) : "No registrado"
                }
                shrink={shrink}
                disabled
                size={gridSizeMdLg6}
            />
            <CustomTextFieldNoForm
                label="Hora de Finalización"
                value={
                    form.getValues()?.fecha_hora_fin_visita ?
                        formatDateWithTime(form.getValues().fecha_hora_fin_visita) : "No registrado"
                }
                shrink={shrink}
                disabled
                size={gridSizeMdLg6}
            />

        </>

    )
}